import { Box, Container, styled, Typography } from '@mui/material';
import { useRouteError } from 'react-router-dom';
import { captureException } from '@sentry/react';
import { useEffect } from 'react';
import Logo from '../assets/logo.webp';

const LogoImage = styled('img')({
  maxWidth: 150,
});

const ErrorPage = () => {
  const error = useRouteError();
  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          translate: '-50%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <LogoImage src={Logo} alt="logo" />
        <Typography variant="subtitle1">
          Något gick fel, och utvecklarna har blivit meddelade.
        </Typography>
      </Box>
    </Container>
  );
};

export default ErrorPage;
